import { h, Fragment } from "preact";
import { prettyPhase } from "../../tools";

export default function DeviceBadInfo({
  device,
  contract,
  account,
  formParams,
}) {
  // С 22.06.2020 НЭС попросили скрывать все сообщения о МПИ
  const now = new Date();
  const june22 = new Date(2020, 5, 22);

  if (now >= june22) {
    return "";
  }

  let text = null;
  let buttonName = null;
  let hasButtonIcon = false;
  let { texts, badDeviceHandler } = formParams;
  let buttonHandler = () => {};

  switch (device.stateStatus) {
    case "working":
      switch (device.mpiStatus) {
        case "expired":
          const [day, month, year] = device.dateStateVerification.split(".");
          const dateStateVerification = new Date(year, month - 1, day);
          const maxDate = new Date(2020, 3, 1);

          if (dateStateVerification <= maxDate)
            text = texts.deviceWorkingMpiExpiredBeforeApril2020;
          else text = texts.deviceWorkingMpiExpiredAfterApril2020;

          buttonName = "Замена прибора учета";
          hasButtonIcon = true;
          buttonHandler = () =>
            badDeviceHandler.replaceRegPoint(prettyPhase(device.phase));
          break;

        case "expires_soon":
          // Электроэнергия
          if (contract.prodType === 1) {
            const [day, month, year] = device.dateStateVerification.split(".");
            const dateStateVerification = new Date(year, month - 1, day);

            const maxDate = new Date(
              now.getFullYear(),
              now.getMonth() + 3,
              now.getDate()
            );

            if (dateStateVerification >= maxDate) {
              text = texts.deviceWorkingMpiExpiresSoon.replace(
                "#DATE#",
                device.dateStateVerification
              );
              text = texts.deviceWorkingMpiExpiresSoon;
              buttonName = "Замена прибора учета";
              hasButtonIcon = true;
              buttonHandler = () =>
                badDeviceHandler.replaceRegPoint(prettyPhase(device.phase));
            }
          }
          break;
      }
      break;

    case "missing":
      // Электроэнергия
      if (contract.prodType === 1) {
        text = texts.energyDeviceMissing;
      }
      break;

    case "not_work":
      // Электроэнергия
      if (contract.prodType === 1) {
        switch (device.mpiStatus) {
          case "ok":
            text = texts.energyDeviceNotWorkingMpiOk;
            break;

          case "expired":
            text = texts.energyDeviceNotWorkingMpiExpired;
            buttonName = "Замена прибора учета";
            hasButtonIcon = true;
            buttonHandler = () =>
              badDeviceHandler.replaceRegPoint(prettyPhase(device.phase));
            break;
        }
      } else {
        text = texts.notEnergyDeviceNotWorking;
        buttonName = "Вызвать мастера";
      }
      break;
  }

  if (!text && !buttonName) return <Fragment />;
  return (
    <div className="debt-table-item-2__row">
      <div className="debt-table-item-2__col" />
      <div className="debt-table-item-2__col debt-table-item-2__col_fg_1">
        <div className="debt-table-item-2__text">
          {!!text && text.length > 0 && (
            <div dangerouslySetInnerHTML={{ __html: text }} />
          )}
          {!!buttonName && (
            <button
              className="button-primary button-primary_bgc_brand-2 button-primary_pdv_sm debt-table-item-2__counter-btn"
              onClick={buttonHandler}
            >
              <span className="button-primary__text">{buttonName}</span>
              {hasButtonIcon && (
                <span className="button-primary__icon button-primary__icon_sz_sm js__tooltip tooltipstered">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z"
                      fill="black"
                    ></path>
                  </svg>
                </span>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
